// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 37) return "static/js/e6cc36a28e5d51b9b9e2.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"383b00680c7b4e6deaca","141":"49cce5f022ff44a3d782","142":"0485ced59eab3c5217ea"}[chunkId] + ".chunk.js";
};